"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuList = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var BDSNavigationMenu_1 = require("../../Elements/BDSNavigationMenu/BDSNavigationMenu");
var MenuList = function (props) {
    var items = props.items, isCollapsedSideBar = props.isCollapsedSideBar, isHoveredCollapsedSideBar = props.isHoveredCollapsedSideBar, activeSync = props.activeSync, handleActiveSync = props.handleActiveSync, menuNum = props.menuNum;
    var _a = react_1.useState(Array(items.length).fill(false)), menuActive = _a[0], setMenuActive = _a[1];
    var _b = react_1.useState(false), isIncludingHiddenMenu = _b[0], setIsIncludingHiddenMenu = _b[1];
    var handleMenu = react_1.useCallback(function (i) {
        var initMenu = Array(items.length).fill(false);
        setMenuActive(initMenu);
        setMenuActive(initMenu.fill(true, i, i + 1));
    }, []);
    react_1.useEffect(function () {
        if (menuNum !== activeSync) {
            var initMenu = Array(items.length).fill(false);
            setMenuActive(initMenu);
        }
    }, [activeSync]);
    return (jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "side-nav-menu-wrapper" }, { children: [jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "side-nav-menu" }, { children: items.map(function (item, i) {
                    if (item.isHidden) {
                        if (!isIncludingHiddenMenu) {
                            setIsIncludingHiddenMenu(true);
                        }
                        return null;
                    }
                    return (jsx_runtime_1.jsx("div", tslib_1.__assign({ onClick: function () {
                            handleActiveSync(menuNum);
                            handleMenu(i);
                        } }, { children: jsx_runtime_1.jsx(BDSNavigationMenu_1.BDSNavigationMenu, { isActiveAlarm: item.isActiveAlarm, label: isHoveredCollapsedSideBar || !isCollapsedSideBar ? item.label : '', icon: item.icon, handleOnClick: function (link) { return item.callback(link !== null && link !== void 0 ? link : item.link); }, active: item.isActive !== undefined ? item.isActive : menuActive[i], menu: !isHoveredCollapsedSideBar && isCollapsedSideBar ? undefined : item.subMenu }, void 0) }), item.id));
                }) }), void 0),
            isIncludingHiddenMenu && (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "side-nav-menu hidden" }, { children: items.map(function (item, i) {
                    if (!item.isHidden)
                        return null;
                    return (jsx_runtime_1.jsx("div", tslib_1.__assign({ onClick: function () {
                            handleActiveSync(menuNum);
                            handleMenu(i);
                        } }, { children: jsx_runtime_1.jsx(BDSNavigationMenu_1.BDSNavigationMenu, { isActiveAlarm: item.isActiveAlarm, label: isHoveredCollapsedSideBar || !isCollapsedSideBar ? item.label : '', icon: item.icon, handleOnClick: function (link) { return item.callback(link !== null && link !== void 0 ? link : item.link); }, active: item.isActive !== undefined ? item.isActive : menuActive[i], menu: !isHoveredCollapsedSideBar && isCollapsedSideBar ? undefined : item.subMenu }, void 0) }), item.id));
                }) }), void 0))] }), void 0));
};
exports.MenuList = MenuList;
